// Specifies common dashboard behaviour for all countries

export const dashboardModules = {
  PRODUCTS: 'products',
  PROMO_BANNER: 'promo-banner',
  PROMOTIONS: 'promotions',
  REWARDS: 'rewards',
  ARTICLES: 'articles',
};

export default {
  dashboardModules,
};
